import type {
  ApiDocument,
  ApiRequestPathParamType,
  ApiRequestQueryParamType,
  FetchService,
} from '@izimi/api';
import { DocumentsApi } from '@izimi/api';
import { buildQueryString } from '@izimi/utils';

import type { UploadDocumentValues } from './types';

class ExtendedDocumentsApi extends DocumentsApi {
  constructor(protected fetchService: FetchService) {
    super(fetchService);
  }

  downloadDocument(
    { documentId }: ApiRequestPathParamType<'downloadDocument'>,
    params?: ApiRequestQueryParamType<'downloadDocument'>,
  ) {
    const qs = buildQueryString(params);
    return this.fetchService.get<Blob>(`${this.baseUrl}/${documentId}/download${qs}`, {
      resAsBlob: true,
    });
  }

  uploadDocument(
    values: UploadDocumentValues,
    onProgress: XMLHttpRequestEventTarget['onprogress'],
    signal: AbortSignal,
  ) {
    const formData = new FormData();
    formData.append('file', values.file);
    formData.append('documentName', values.file.name);
    formData.append('labels', values.labels.join(','));
    formData.append('shareable', values.isShareable.toString());
    if (values.categories) {
      formData.append('categories', values.categories.join(','));
    }

    return this.fetchService.uploadFile<ApiDocument>(this.baseUrl, formData, onProgress, {
      signal,
    });
  }
}

export default ExtendedDocumentsApi;
